import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const ReportModal = ({ selectedItem, reporterId, show, onClose, onSubmitReport }) => {
    const [reason, setReason] = useState('');
    const [details, setDetails] = useState('');
    const isSubmitDisabled = !reason;
    const isMobile = window.innerWidth <= 768;

    if (!selectedItem || isMobile) {
        return null;
    };

    const buildReasonText = () => {
        if (!details.trim()) return reason;

        return `${reason}: ${details.trim()}`;
    };


    const submitReport = () => {
        const combinedReason = buildReasonText();
        onSubmitReport({
            reportedId: selectedItem.actorId,
            itemId: selectedItem.rawItemId,
            itemType: selectedItem.type,
            reason: combinedReason,
            reporterId
        });

        onClose();
    };


    return (
        <Modal
            show={show}
            onHide={onClose}
            aria-labelledby="custom-modal-styling"
            className="custom-modal"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div>Report Content</div>
                    <div>{selectedItem.type}</div>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Reason for report</Form.Label>
                        <Form.Select
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            required
                        >
                            <option value="" style={{ color: 'black'}}>Select a reason</option>
                            <option value="IMAGE" style={{ color: 'black'}}>Not a karuta image</option>
                            <option value="Ownership" style={{ color: 'black'}}>Does not own Card</option>
                            <option value="Offensive" style={{ color: 'black'}}>Offensive text</option>
                            <option value="OTHER" style={{ color: 'black'}}>Other</option>
                        </Form.Select>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Additional details (optional)</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={details}
                            onChange={(e) => setDetails(e.target.value)}
                            placeholder="Provide any additional context for moderators"
                            limit={25}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>

            <Modal.Footer style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button variant="outline-secondary" onClick={submitReport} disabled={isSubmitDisabled}>
                    Submit
                </Button>
                <Button variant="outline-secondary" onClick={onClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ReportModal;
